import * as z from "zod";

export const outreachScopes = [
  "automation",
  "automationStepId",
  "campaign",
  "template",
] as const;

export type OutreachScopeValues = Partial<
  Record<(typeof outreachScopes)[number], string | null>
>;

/** The grain a set of outreach metrics is reported at. */
export type OutreachScope = keyof OutreachScopeValues;

export const outreachScopeValuesSchema = z
  .object({
    automation: z.string().nullish(),
    automationStepId: z.string().nullish(),
    campaign: z.string().nullish(),
    template: z.string().nullish(),
  })
  .partial();

export const outreachProducts = ["marketing", "order tracking"] as const;

export const outreachMetrics = [
  "complaints",
  "bounces",
  "sends",
  "deliveries",
  "opens",
  "uniqueOpens",
  "clicks",
  "uniqueClicks",
  "upsellCount",
  "upsellRevenue",
  "failures",
  "skippedDueToUnsubscribe",
  "skippedDueToSkipConditions",
] as const;

export type OutreachMetric = (typeof outreachMetrics)[number];

export enum OutreachEventType {
  Complaint = "complaint",
  Bounce = "bounce",
  Send = "send",
  Delivery = "delivery",
  Open = "open",
  Click = "click",
}

export const validOutreachScopeSets: Set<keyof OutreachScopeValues>[] = [
  new Set([]),
  new Set(["campaign"]),
  new Set(["campaign", "template"]),
  new Set(["automation"]),
  new Set(["automation", "automationStepId"]),
  new Set(["automation", "automationStepId", "template"]),
];
